const initialState = {
    progressStatusAudio : 0
}

const progStatus = (state = initialState , action) =>{
    switch(action.type){
        case "AUDIO_PROGRESS" : 
            return {
                ...state,
                ...{
                    progressStatusAudio : action.payload.progressStatusAudio
                }


            }

        case "RESET_PROGRESS_STATUS" :
            return {
                ...state,
                ...{
                    progressStatusAudio : 0

                }
            }

        default: return state;
    }

   
}

export default progStatus;